
import React from 'react';
import { useCTAL } from './CTAL_Hooks.js';

export default function LongListInformation() 
{
    const { setActionItem } = useCTAL();

    setActionItem();

    return ( 
        <> 
            <div class="alert alert-light mt-2" role="alert">
                <small>
                    <p>Life is not easily compartmentalized between our work and personal lives. Your Short List needs to reflect this reality and contain both 
                    Work and Private action-items. 
                    </p>

                    <p>Here <strong><em>private means private</em></strong>. Items on this Long List can easily be moved back and forth to
                    your Short List (items you are actively working on) but <strong><em>they will never be visible to anyone else</em></strong> (unless they are standing behind you).</p>

                    <p>As new personal to-do's come up, add them to this private Long List and only move them to your Short List 
                    when you are ready to prioritze them.</p>

                    <p>This List will give you the freedom to not think about it's contents, safe in the knowledge that you have it in the queue where you can update it with any
                    new information for when it's time to take action!</p>  
                    
                    <p>If you want to share action-items with others (ex. work projects, non-profit organizations, or a family Honey-Do List), then create a new Team or join an existing Team using the User panel and enter your
                       new action items into it's List.</p>

                    <div class="mt-2">
                        Enter a new Action above and click "Create" to get started!
                    </div>
                </small>
            </div>
        </> 
    );
}

//alert-success